import { createFileRoute } from '@tanstack/react-router'
import { MedicationRulesSettingsFeature } from '@/features/organizations/settings/medication-rules'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/medication-rules'
)({
  component: MedicationRulesSettingsFeature,
})
